import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class VegValidators {

static phoneNumber(control: AbstractControl): ValidationErrors | null {
    // Sourced from: https://stackoverflow.com/questions/39990179/regex-for-australian-phone-number-validation
    return VegValidators.vegValidator(/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/, "phoneNumber")(control);
}

static email(control: AbstractControl): ValidationErrors | null {
    // Sourced from: https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript
    return VegValidators.vegValidator(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, "email")(control);
}

static postcode(control: AbstractControl): ValidationErrors | null {
    return VegValidators.vegValidator(/^[0-9]{4}$/, "postcode")(control);
}

static vegValidator(regexPattern: RegExp, fieldName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null =>
        regexPattern.test(control.value) ? null : {vegValidatorError: fieldName + " = " + control.value};
    }
}